<template>
  <div :id="idChart"></div>
</template>

<script>
import moment from 'moment';
import Highcharts from "highcharts";
import HighChartsMore from 'highcharts/highcharts-more';
import Accessibility from 'highcharts/modules/accessibility';
import Exporting from 'highcharts/modules/export-data';
Accessibility(Highcharts);
Exporting(Highcharts);
HighChartsMore(Highcharts);
export default {
    name: 'UsefulVolumeAreaChart',
    props:['basin', 'periodDate', 'volumeData', 'unitMeasurement', 'idChart'],
    data:()=>({
        chartRendered: undefined,
    }),
    computed:{
        operationalMaxQuote(){
            return this.basin && this.basin.COTA_MAXIMA_OPERACIONAL ? this.basin.COTA_MAXIMA_OPERACIONAL : undefined;
        },
        operationalMinQuote(){
            return this.basin && this.basin.COTA_MINIMA_OPERACIONAL ? this.basin.COTA_MINIMA_OPERACIONAL : undefined;
        }
    },
    methods:{
        chartPreprocessing(){
            const elementId = this.idChart;
            let chart = document.getElementById(elementId)
            const series = this.createDataSerie(this.volumeData);
            if(series){
                this.charts(elementId, series )
                this.loading = false
                chart.style.visibility = 'visible'
                chart.style.display = 'block'
            } else {
                chart.style.visibility = 'hidden'
                chart.style.display = 'none'
            }

            this.$emit('chartRenderComplete', this.chartRendered);
        },
        async charts(elementId, series){
            Highcharts.setOptions({
                lang: {
                    months: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                    shortMonths: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
                    weekdays: ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'],
                }
            });
            if (this.periodDate) {
            this.chartRendered = Highcharts.chart(elementId, {
                colorAxis:{
                    gridLineColor: this.$vuetify.theme.themes.dark.primary.darken1,
                },
                chart: {
                    inverted: false,
                    backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
                    height: 400
                },
                plotOptions:{
                    areaspline: {
                        fillOpacity: 0.5
                    }
                },
                exporting: {
                    enabled: false,
                    filename: `Volume área - ${this.basin.text}`,
                    sourceWidth: 1000,

                    chartOptions:{
                        title: {
                            text: `Volume área - ${this.basin.text}`,
                            style:{
                                color: '#FFFFFF'
                            }
                        },
                        subtitle: {
                            text: `Dados de ${this.formatDate(this.periodDate.period[0])} a ${this.formatDate(this.periodDate.period[1])}`,
                            style:{
                                color: '#FFFFFF'
                            },
                        },

                        xAxis: {
                            tickInterval: this.periodDate.type === 'Diário' ? 24*3600*1000 : 30*24*3600*1000
                        },
                    }
                },
                title: {
                    text: ''
                },
                credits: {
                    enabled: true,
                    href: 'http://www.simepar.br/',
                    text:'by: SIMEPAR',
                    style:{
                        color: '#FFFFFF'
                    }
                },
                legend: {
                  enabled: true,
                  itemStyle:{
                    color: '#FFFFFF',
                  },
                  itemHoverStyle: {
                    color: '#979797'
                  },
                },
                xAxis: {
                    accessibility:{
                        description:`De ${this.formatDate(this.periodDate.period[0])} até ${this.formatDate(this.periodDate.period[1])}`
                    },
                    tickColor: '#2D324F',
                    tickWidth: 2,
                    lineWidth: 2,
                    lineColor: '#2D324F',
                    type: 'datetime',
                    ordinal: false,
                    crosshair: {
                        enabled: true
                    },
                    //tickInterval: 12* 3600*1000,
                    labels:{
                        format: this.periodDate.type === 'Diário' ? '{value:%d/%m/%y}' : '{value:%b/%y}',
                        style:{
                        color: '#FFFFFF'
                        },
                        rotation: -45
                    },
                },
                yAxis: {
                    title: {
                      text: 'Volume ( hm³ )',
                      style:{
                          color: '#FFFFFF'
                      }
                    },
                    accessibility:{
                        description: 'Volume ( hm³ )'
                    },
                    labels:{
                        style:{
                          color: '#FFFFFF'
                      }
                    },
                    plotLines: [
                        {
                            value: this.operationalMaxQuote,
                            width: 3,
                            color: '#00C4F0',
                            zIndex: 1
                        },
                        {
                            value: this.operationalMinQuote,
                            width: 3,
                            color: '#6D3F8C',
                            zIndex: 1
                        }
                    ]

                },
                tooltip:{
                    shared: true,
                    split: true,
                    useHTML: true,
                    xDateFormat: this.periodDate.type === 'Diário' ? '%A, %d de %B de %Y' : '%B de %Y',
                    pointFormatter: function() {
                        const tooltipText = this.options.tooltipText ? this.options.tooltipText : this.series.name;
                        const value = this.series.userOptions.valueDecimals ? Number(this.y).toFixed(this.series.userOptions.valueDecimals) : this.y;
                        const unitMeasurement = this.series.userOptions.unitMeasurement ? this.series.userOptions.unitMeasurement : 'hm³';
                        return '<strong style="color:' + this.options.color +'">' + tooltipText + '</strong>: <strong>' + value + ' ' + unitMeasurement + '<strong/>'
                    },
                },
                series:[
                  ...series,
                //   {
                //     name: 'cota máxima operacional',
                //     color: '#00C4F0',
                //     marker: {
                //         symbol: 'circle',
                //     },
                //     events:{
                //         legendItemClick: (e)=>{e.preventDefault()},
                //     },
                //   },
                //   {
                //     name: 'cota mínima operacional',
                //     color: '#6D3F8C',
                //     marker: {
                //         symbol: 'circle'
                //     },
                //     events:{
                //         legendItemClick: (e)=>{e.preventDefault()},
                //     },
                // }
                ],
                caption:{
                    text: `Gráfico de volume com dados medidos em (hm³) de ${this.formatDate(this.periodDate.period[0])} até ${this.formatDate(this.periodDate.period[1])}`,
                    style:{color: '#FFFFFF'},
                },
                responsive: {
                    rules: [{
                        condition: {
                            maxWidth: 500
                        },
                        chartOptions: {
                            legend: {
                                layout: 'horizontal',
                                align: 'center',
                                verticalAlign: 'bottom'
                            }
                        }
                    }]
                }
            });
            }
        },
        createDataSerie(rawData){
            const dataPeriod = [];
            for(const key in rawData){
                const dataItemPeriod = {
                  y: rawData[key].valor,
                  color: 'rgba(132, 166, 254, 0.83)',
                  x: new Date(rawData[key].data).getTime(),
                };

                dataPeriod.push(dataItemPeriod);
            }

            return [
                {
                    type: "areaspline",
                    name: 'volume',
                    data: dataPeriod,
                    unitMeasurement: this.unitMeasurement,
                    valueDecimals: 3
                },
            ];
        },

        formatDate(date){
            const stringFormat = this.periodDate.type === 'Diário' ? 'DD/MM/YYYY' : 'MMMM/YYYY';
            return moment(date).locale('pt-br').format(stringFormat);
        }
    }
}
</script>

<style>

</style>
